export const RegisterPath = '/register';
export const HomePath = '/';
export const LoginPath = '/login';
export const VerifyPath = '/verify';
export const LogoutPath = '/logout';
export const SignUpPath = '/signup';
export const InvitePath = '/invite';
export const OAuthConsentPath = '/consent';
export const IntegrationsPath = '/settings/integrations';
export const ErrorPath = '/error';
export const SlackAdminApprovedPath = '/slack-admin-approved';

export const IntegrationsConnectPath = '/settings/integrations/connect';

export const ServicesPath = '/services';

export const ServiceDetailsPath = (serviceId: string) =>
  `/services/${serviceId}`;

export const orgUrl = (slug: string, domain: string) =>
  `https://${slug}.${domain}`;

export const integrationAuthUrl = (
  integrationId: string,
  inputParams: string,
  orgSlug: string,
  domain: string
) =>
  `https://api.${domain}/oauth/${integrationId}/auth?org=${orgSlug}&input=${inputParams}`;

export const JobDetailsPath = (jobId: string) => `/jobs/${jobId}`;

export const SettingsPathGeneral = '/settings/general';
export const SettingsPathSso = '/settings/sso';
export const SettingsPathAuditLogs = '/settings/auditlogs';
export const SettingsPathNotifications = '/settings/notifications';
export const SettingsPathDeployments = '/settings/deployments';
export const SettingsPathAuthServers = '/settings/auth-servers';

export const ProfileSettingsPathApiKey = '/profile-settings/api-keys';

// AI Paths
export const AddCustomPath = (basePath: string) => basePath + '/custom';
export const MyConnectionsPath = '/my-connections';
export const MyAgentsPath = '/my-agents';
// Manage Paths
export const ManagedConnectionsPath = '/managed-connections';
export const AppsPath = '/apps';
export const AppsAddManagedConnectionsPath = AppsPath + '/add-managed';
export const AppsEditPath = AppsPath + '/edit';
export const AppsEnablePath = AppsPath + '/enable';
export const ProfilesPath = '/profiles';
export const DirectoryPath = '/directory';
export const DirectoryUsersPath = '/directory/users';
export const AgentsPath = '/agents';
export const AccessPath = '/access';
export const ActivityPath = '/activity';
export const ShadowAIPath = '/shadow-ai';
export const DiscoveredAIClientsPath = `/shadow-ai/clients`;
export const DiscoveredAIClientDetailPath = (configFileType: string) =>
  `/shadow-ai/clients/${encodeURIComponent(configFileType)}`;

export const TunnelsPath = '/tunnels';

export const SettingsPath = (tab: string) => `/settings/${tab.toLowerCase()}`;

export const RedirectablePathsPostLogin = [OAuthConsentPath];
